import { Link } from 'react-router-dom';
import Navbar from '@/components/Landing/Navbar';
import Footer from '@/components/Landing/Footer';

export default function NotFoundPage() {
  return (
    <div className="landing-layout">
      <Navbar />
      <main style={{ paddingTop: '70px' }}>
        <section className="px-6 py-32 sm:py-40 bg-background">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-muted-foreground uppercase tracking-[0.2em] text-xs font-medium mb-4">404</p>
            <h1 className="text-foreground font-serif" style={{ fontSize: 'clamp(34px, 5vw, 56px)', lineHeight: 1.15, fontWeight: 700 }}>
              Page not found
            </h1>
            <p className="text-muted-foreground text-lg mt-6" style={{ lineHeight: 1.8 }}>
              The page you're looking for doesn't exist or has been moved.
            </p>
            <div className="mt-10 flex items-center justify-center gap-4">
              <Link
                to="/"
                className="rounded-full bg-primary px-7 py-3 text-sm font-semibold text-primary-foreground hover:opacity-90 transition-opacity"
              >
                Go to homepage
              </Link>
              <Link
                to="/articles"
                className="rounded-full border border-border px-7 py-3 text-sm font-semibold text-foreground hover:bg-card transition-colors"
              >
                Browse articles
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
